<template>
  <div
    class="flex items-center justify-center shrink-0 bg-cover bg-center relative"
    :class="[
      size === 'lg' ? 'size-24 rounded-2xl' : (
      size === 'md' ? 'size-14 rounded-xl' : 'size-12 rounded-xl' ),
      event ? 'text-white bg-charcoal-950' : (
        isGroup ? 'bg-urchin-200 text-urchin-950' : ''
      ),
    ]"
  >
    <img
      :src="event?.image?.getSize('s')" class="w-full h-full absolute object-cover top-0 left-0"
      :class="[
        event ? (event.isPastAfter ? 'saturate-0 opacity-80' : 'opacity-80') : '',
        size === 'lg' ? 'size-24 rounded-2xl' : (
        size === 'md' ? 'size-18 rounded-2xl' : 'size-12 rounded-xl')
      ]"
      loading="lazy"
      v-if="event?.image"
    />
    
    <IconBase name="cute/map-marker-fill" class="relative" :width="size === 'lg' || size === 'md' ? 28 : 24" v-if="event" />
    <ImageEmoji :name="group.icon ?? 'Grinning+Face+with+Smiling+Eyes'" class="shrink-0" :class="[ size === 'lg' || size === 'md' ? 'size-9' : 'size-8' ]" :size="size === 'lg' || size === 'md' ? 'base' : 'sm'" v-else-if="group" />
    <UserPicture
      :user="user"
      :size="size === 'lg' ? '2xl' : 'base'"
      is-link
      is-online
      @click.stop
      v-else-if="user"
    />
  </div>
</template>

<script lang="ts" setup>
import { Conversation, Event, Group } from '@/classes'
import UserStore from '@/store/user'
import UsersStore from '@/store/users'

const props = withDefaults(defineProps<{
  conversation?: Conversation
  group?: Group | null
  event?: Event | null
  size?: 'base' | 'md' | 'lg'
  isActive?: boolean
  isRead?: boolean
}>(), {
  size: 'base'
})

const usersStore = UsersStore()
const userStore = UserStore()
const { currentUser } = storeToRefs(userStore)

const user = computed(() => {
  const target = [ ...(props.conversation?.users ?? []), ...(props.conversation?.invited ?? []) ].find(userId => userId !== currentUser.value?._id)

  return target ? usersStore.getItem(target) : null
})

const isGroup = computed(() => (props.conversation?.users ?? []).length > 2 || props.conversation?.type === 'group' || props.group)

</script>